jQuery(function ($) {
  // Add smooth scroll to anchor links. Just add the "smooth" class to your links
  $('.smooth[href*="#"]:not([href="#"])').click(function () {
    if (
      location.pathname.replace(/^\//, "") ==
        this.pathname.replace(/^\//, "") &&
      location.hostname == this.hostname
    ) {
      let target = $(this.hash);
      target = target.length ? target : $("[name=" + this.hash.slice(1) + "]");
      if (target.length) {
        $("html,body").animate(
          {
            scrollTop: target.offset().top - 40,
          },
          500
        );
        return false;
      }
    }
  });

  // Navbar Submenu Dropdown Links Click - Mobile
  $(".menu-toggle").on("click", function (e) {
    $(this).toggleClass("collapsed");

    var $subMenu = $(this).parent().next(".sub-menu");
    $subMenu.toggleClass("slideInUp animated show");

    return false;
  });

  // Navbar Toggler
  $(".nav-toggler").on("click", function (e) {
    $(".nav-search-icon").removeClass("nav-search-icon--close");
    $("#search-box").css("display", "none");
    $(this).toggleClass("is-active");
    $("div.nav-collapse").toggleClass("show");
  });

  // Menu Search Trigger
  $(".nav-search-icon").click(function (e) {
    e.stopPropagation();
    e.preventDefault();
    $(".nav-toggler").removeClass("is-active");
    $(".nav-collapse").removeClass("show");
    $(this).toggleClass("nav-search-icon--close");
    $("#search-box").fadeToggle(350);
    $("#search-box .search-field").focus();
  });

  // Hide Menu Search Trigger on Document Click
  $(document).on("click", function (event) {
    const eventClick = $(event.target).closest("#search-box").length;

    if (!eventClick) {
      $("#search-trigger").removeClass("nav-search-icon--close");
      $("#search-box").fadeOut(350);
    }
  });

  // Sticky Navigation Bar
  const stickyToggle = function (sticky, stickyWrapper, scrollElement) {
    const stickyHeight = sticky.outerHeight();
    const stickyTop = stickyWrapper.offset().top;

    const navCart = $(".woo-shopping-cart-wrapper.nav-cart");
    const topOrderButton = $(".nav-menu > .order-button");
    const ctaInfo = $(".top-bar-cta__info");

    const navLogo = $(".nav-logo");

    if (scrollElement.scrollTop() >= stickyTop) {
      stickyWrapper.height(stickyHeight);
      sticky.addClass("is-sticky active");
      navCart.insertBefore(topOrderButton);

      if ($(window).width() < 1200) {
        navCart.insertAfter(navLogo);
      }
    } else {
      sticky.removeClass("is-sticky active");
      stickyWrapper.height("auto");

      if ($(window).width() > 1200) {
        navCart.insertAfter(ctaInfo);
      }
    }
  };

  // Find all data-toggle="sticky-onscroll" elements
  $('[data-toggle="sticky-onscroll"]').each(function () {
    var sticky = $(this);
    var stickyWrapper = $("<div>").addClass("sticky-wrapper");
    sticky.before(stickyWrapper);
    sticky.addClass("sticky");

    // Scroll & resize events
    $(window).on("scroll.sticky-onscroll resize.sticky-onscroll", function () {
      stickyToggle(sticky, stickyWrapper, $(this));
    });

    // On page load
    stickyToggle(sticky, stickyWrapper, $(window));
  });

  // Contact Form 7 Placeholder Hide on Focus
  $("input,textarea")
    .focus(function () {
      $(this)
        .data("placeholder", $(this).attr("placeholder"))
        .attr("placeholder", "");
    })
    .blur(function () {
      $(this).attr("placeholder", $(this).data("placeholder"));
    });

  // TOC+ Container - Show On Click
  $(".toc_title").click(function () {
    if ($(this).text() == "Show Contents") {
      $(this).text("Hide Contents");
    } else {
      $(this).text("Show Contents");
    }
    $(this).toggleClass("is-open");

    $("ul.toc_list").slideToggle("300");
  });

  // Comments - Add Padding to Comment Respond
  $(".comment-reply-link").click(function () {
    $(".comment-respond").addClass("is-open");
  });

  $("#cancel-comment-reply-link").click(function () {
    $(".comment-respond").removeClass("is-open");
  });

  // Back To Top Button
  $(window).scroll(function () {
    if ($(this).scrollTop() > 200) {
      $(".backtotop").fadeIn();
    } else {
      $(".backtotop").fadeOut();
    }
  });

  $(".backtotop").click(function () {
    $("html, body").animate({ scrollTop: 0 }, 600);
    return false;
  });
});
